import { useMemo } from 'react';
import { checkGoUser } from '../Util/User';
import useInspireOptions from './useInspireOptions';
import { Profile } from '../Types';

const useIsRevampedProxyEnabled = (profile: Profile) => {
  const { isExclusivelyTm } = useInspireOptions();

  return useMemo(() => {
    // Only non-GO users who are TMs (not OMs) should have the revamped proxy feature
    return isExclusivelyTm && !checkGoUser(profile.user?.owner);
  }, [isExclusivelyTm, profile?.user?.owner]);
};

export default useIsRevampedProxyEnabled;
